import React, { useState } from "react";
import "./HotelWebsite4.css";

const HotelWebsite4 = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState(null);

  // --- 30 FRESH HOTEL PROPERTIES ---
  const hotelData = [
    { id: 1, name: "Mint & Palm Resort", loc: "Maldives", price: "42,000", cat: "Resort", img: "https://images.unsplash.com/photo-1540541338287-41700207dee6?auto=format&fit=crop&w=800", vibe: "Refreshing" },
    { id: 2, name: "The Lemon Grove", loc: "Sicily, Italy", price: "18,500", cat: "Boutique", img: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=800", vibe: "Organic" },
    { id: 3, name: "Urban Jungle Stay", loc: "Singapore", price: "12,000", cat: "Urban", img: "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=800", vibe: "Vibrant" },
    { id: 4, name: "Glass Alpine Cabin", loc: "Norway", price: "28,000", cat: "Eco", img: "https://images.unsplash.com/photo-1510798831971-661eb04b3739?auto=format&fit=crop&w=800", vibe: "Pure" },
    { id: 5, name: "Coral Reef Suites", loc: "Thailand", price: "15,000", cat: "Beach", img: "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?auto=format&fit=crop&w=800", vibe: "Lively" },
    { id: 6, name: "The White Loft", loc: "Mykonos", price: "35,000", cat: "Boutique", img: "https://images.unsplash.com/photo-1439130490301-25e322d88054?auto=format&fit=crop&w=800", vibe: "Minimal" },
    { id: 7, name: "Bamboo Rain", loc: "Bali", price: "9,500", cat: "Eco", img: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=800", vibe: "Natural" },
    { id: 8, name: "Neon City View", loc: "Tokyo", price: "22,000", cat: "Urban", img: "https://images.unsplash.com/photo-1503899036084-c55cdd92da26?auto=format&fit=crop&w=800", vibe: "Dynamic" },
    { id: 9, name: "Desert Mirage", loc: "Dubai", price: "48,000", cat: "Luxury", img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=800", vibe: "Grand" },
    { id: 10, name: "The Surf House", loc: "Australia", price: "14,000", cat: "Beach", img: "https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?auto=format&fit=crop&w=800", vibe: "Active" },
    { id: 11, name: "Sage Hill Spa", loc: "Switzerland", price: "55,000", cat: "Resort", img: "https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?auto=format&fit=crop&w=800", vibe: "Calm" },
    { id: 12, name: "Art District Inn", loc: "Berlin", price: "11,000", cat: "Urban", img: "https://images.unsplash.com/photo-1439130490301-25e322d88054?auto=format&fit=crop&w=800", vibe: "Creative" },
    { id: 13, name: "Blue Lagoon Villa", loc: "Maldives", price: "75,000", cat: "Luxury", img: "https://images.unsplash.com/photo-1596394516093-501ba68a0ba6?auto=format&fit=crop&w=800", vibe: "Exotic" },
    { id: 14, name: "Heritage Haveli", loc: "India", price: "12,500", cat: "Heritage", img: "https://images.unsplash.com/photo-1599661046289-e31897846e41?auto=format&fit=crop&w=800", vibe: "Timeless" },
    { id: 15, name: "Lakeside Manor", loc: "Canada", price: "24,000", cat: "Resort", img: "https://images.unsplash.com/photo-1519449556851-5720b33024e7?auto=format&fit=crop&w=800", vibe: "Serene" },
    { id: 16, name: "The Sky Garden", loc: "London", price: "38,000", cat: "Urban", img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800", vibe: "Elite" },
    { id: 17, name: "Hidden Forest Lodge", loc: "Costa Rica", price: "19,000", cat: "Eco", img: "https://images.unsplash.com/photo-1510798831971-661eb04b3739?auto=format&fit=crop&w=800", vibe: "Lush" },
    { id: 18, name: "Sunset Santorini", loc: "Greece", price: "40,000", cat: "Beach", img: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=800", vibe: "Romantic" },
    { id: 19, name: "The Jazz Corner", loc: "New Orleans", price: "13,500", cat: "Boutique", img: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=800", vibe: "Soulful" },
    { id: 20, name: "Marble Palace", loc: "Rome", price: "32,000", cat: "Heritage", img: "https://images.unsplash.com/photo-1549294413-26f195200c16?auto=format&fit=crop&w=800", vibe: "Royal" },
    { id: 21, name: "Safari Glamp", loc: "Tanzania", price: "45,000", cat: "Eco", img: "https://images.unsplash.com/photo-1493246318656-5bbd4afb293c?auto=format&fit=crop&w=800", vibe: "Wild" },
    { id: 22, name: "The Glass Tower", loc: "Hong Kong", price: "28,000", cat: "Urban", img: "https://images.unsplash.com/photo-1541432901042-2d8bd64b4a6b?auto=format&fit=crop&w=800", vibe: "Modern" },
    { id: 23, name: "Zen Temple Stay", loc: "Kyoto", price: "15,500", cat: "Boutique", img: "https://images.unsplash.com/photo-1542051841857-5f90071e7989?auto=format&fit=crop&w=800", vibe: "Peaceful" },
    { id: 24, name: "Ibiza Sound Hotel", loc: "Spain", price: "25,000", cat: "Beach", img: "https://images.unsplash.com/photo-1582610116397-edb318610fca?auto=format&fit=crop&w=800", vibe: "Electric" },
    { id: 25, name: "Emerald River Lodge", loc: "Vietnam", price: "7,500", cat: "Eco", img: "https://images.unsplash.com/photo-1528127220108-1558304b4b3c?auto=format&fit=crop&w=800", vibe: "Fresh" },
    { id: 26, name: "The Castle Inn", loc: "Edinburgh", price: "20,000", cat: "Heritage", img: "https://images.unsplash.com/photo-1518780664697-55e3ad937233?auto=format&fit=crop&w=800", vibe: "Mystic" },
    { id: 27, name: "Oyster Bay Resort", loc: "South Africa", price: "22,500", cat: "Resort", img: "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?auto=format&fit=crop&w=800", vibe: "Panoramic" },
    { id: 28, name: "Tulip Garden Hotel", loc: "Netherlands", price: "16,000", cat: "Boutique", img: "https://images.unsplash.com/photo-1565426873118-a17ed65d7429?auto=format&fit=crop&w=800", vibe: "Cheerful" },
    { id: 29, name: "Golden Oasis", loc: "Morocco", price: "19,500", cat: "Luxury", img: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=800", vibe: "Warm" },
    { id: 30, name: "Crystal Ice Hotel", loc: "Sweden", price: "33,000", cat: "Eco", img: "https://images.unsplash.com/photo-1476610182048-b716b8518aae?auto=format&fit=crop&w=800", vibe: "Cold" },
  ];

  const categories = [
    { name: "All", icon: "🌈" },
    { name: "Resort", icon: "🍹" },
    { name: "Boutique", icon: "🏺" },
    { name: "Urban", icon: "🏙️" },
    { name: "Eco", icon: "🍃" },
    { name: "Beach", icon: "⛱️" },
    { name: "Luxury", icon: "💎" },
    { name: "Heritage", icon: "🏰" },
  ];

  const filtered = hotelData.filter(h => 
    (activeCategory === "All" || h.cat === activeCategory) &&
    (h.name.toLowerCase().includes(search.toLowerCase()) || h.loc.toLowerCase().includes(search.toLowerCase()))
  );

  const openEnquiry = (hotel) => {
    setSelectedHotel(hotel);
    setShowEnquiry(true);
  };

  return (
    <div className="hotelwebsite4-container">
      {/* --- FLOATING NAVBAR --- */}
      <nav className="hotelwebsite4-navbar">
        <div className="hotelwebsite4-logo"><span>Zotrai.</span></div>
        <div className="hotelwebsite4-nav-right">
            <button className="search-pill" onClick={() => setIsSearchOpen(true)}>
                <span>🔍 Find your vibe...</span>
            </button>
            <button className="menu-btn">☰</button>
        </div>
      </nav>

      {/* --- HERO SPOTLIGHT --- */}
      <section className="hotelwebsite4-hero">
        <div className="hotelwebsite4-hero-card">
            <div className="hero-img-box">
                <img src="https://images.unsplash.com/photo-1540541338287-41700207dee6?auto=format&fit=crop&w=1200" alt="Hero" />
                <span className="hero-tag">Property of the Month</span>
            </div>
            <div className="hero-content">
                <h2>Mint & Palm Resort</h2>
                <p>📍 Kaafu Atoll, Maldives</p>
                <button className="hotelwebsite4-btn-lemon" onClick={() => openEnquiry(hotelData[0])}>Experience Now</button>
            </div>
        </div>
      </section>

      {/* --- STORY FILTERS --- */}
      <div className="hotelwebsite4-stories">
        {categories.map(cat => (
          <div 
            key={cat.name} 
            className={`story-item ${activeCategory === cat.name ? 'active' : ''}`}
            onClick={() => setActiveCategory(cat.name)}
          >
            <div className="story-circle">{cat.icon}</div>
            <span>{cat.name}</span>
          </div>
        ))}
      </div>

      {/* --- DISCOVERY FEED --- */}
      <main className="hotelwebsite4-main">
        <div className="feed-header">
            <h3>Discovery Feed</h3>
            <p>Handpicked for your next getaway</p>
        </div>

        <div className="hotelwebsite4-feed">
          {filtered.map((hotel) => (
            <div className="hotelwebsite4-feed-card" key={hotel.id}>
              <div className="feed-img-box">
                <img src={hotel.img} alt={hotel.name} />
                <div className="feed-vibe-tag">{hotel.vibe}</div>
              </div>
              <div className="feed-details">
                <div className="feed-row">
                    <h4>{hotel.name}</h4>
                    <span className="price">₹{hotel.price}</span>
                </div>
                <p>📍 {hotel.loc}</p>
                <button className="book-btn" onClick={() => openEnquiry(hotel)}>Inquire</button>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* --- SEARCH OVERLAY --- */}
      {isSearchOpen && (
        <div className="hotelwebsite4-search-overlay">
          <button className="close-search" onClick={() => setIsSearchOpen(false)}>✕</button>
          <div className="search-content">
            <input 
              type="text" 
              placeholder="Start typing your destination..." 
              autoFocus 
              onChange={(e) => setSearch(e.target.value)}
            />
            <div className="popular-tags">
                <span>Bali</span> <span>Dubai</span> <span>Luxury</span> <span>Resorts</span>
            </div>
          </div>
        </div>
      )}

      {/* --- ENQUIRY MODAL --- */}
      {showEnquiry && (
        <div className="hotelwebsite4-modal-bg">
          <div className="hotelwebsite4-modal">
            <button className="close-modal" onClick={() => setShowEnquiry(false)}>✕</button>
            <div className="modal-inner">
                <h2>Ready to refresh?</h2>
                {selectedHotel && <p className="selection-txt">Booking: <strong>{selectedHotel.name}</strong></p>}
                <form className="hotelwebsite4-form" onSubmit={(e) => {e.preventDefault(); alert("Enquiry Sent!"); setShowEnquiry(false)}}>
                  <input type="text" placeholder="Full Name" required />
                  <input type="email" placeholder="Email" required />
                  <input type="tel" placeholder="Phone Number" required />
                  <textarea placeholder="Tell us what makes your stay special..."></textarea>
                  <button type="submit" className="hotelwebsite4-btn-lemon full-width">Send Request</button>
                </form>
            </div>
          </div>
        </div>
      )}

      <footer className="hotelwebsite4-footer">
        <p>© 2025 Zotrai Hospitality. Stay Fresh.</p>
      </footer>
    </div>
  );
};

export default HotelWebsite4;